module.exports = __webpack_public_path__ + "static/media/globes_logo.23776821.png";